export const bodyScrollOverflowHidden = () => {
  const body = document.querySelector('body');

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  // // Додаємо паддінг справа, щоб контент не стрибав
  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;
    document.documentElement.style.setProperty('--scrollbar-offset', `${scrollbarWidth / 2}px`);
  }
  body.style.overflow = 'hidden';
};
export const bodyScrollOverflowAuto = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'auto';
  body.style.paddingRight = `0px`;
  document.documentElement.style.setProperty('--scrollbar-offset', `0px`);
};

// Тілики для УкраЇнських номерів
export const phoneCorrect = (phoneNumber) => {
  // phoneCorrect('380930534757') === +380 (93) 053 47 57
  let plus_group = phoneNumber.slice(0, 3);
  let code_group = phoneNumber.slice(3, 5);
  let first_group = phoneNumber.slice(5, 8);
  let second_group = phoneNumber.slice(8, 10);
  let third_group = phoneNumber.slice(10, 12);

  let correct_phone =
    '+' +
    plus_group +
    ' ' +
    '(' +
    code_group +
    ')' +
    ' ' +
    first_group +
    ' ' +
    second_group +
    ' ' +
    third_group;

  return correct_phone;
};
// Тілики для УкраЇнських номерів
export const phoneCorrectWithoutCode = (phoneNumber) => {
  // phoneCorrectWithoutCode('380930534757') === (93) 053 47 57
  let code_group = phoneNumber.slice(3, 5);
  let first_group = phoneNumber.slice(5, 8);
  let second_group = phoneNumber.slice(8, 10);
  let third_group = phoneNumber.slice(10, 12);

  let correct_phone =
    '(' + code_group + ')' + ' ' + first_group + ' ' + second_group + ' ' + third_group;

  return correct_phone;
};

// Генерує унікальний ключ
export const generateRandomString = (length = 15) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  const time_milliseconds = new Date().getTime().toString();

  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));

    // Додає час в мілісікундах
    if (counter < time_milliseconds.toString().length) {
      result += time_milliseconds.charAt(counter);
    }
    counter += 1;
  }

  return result;
};

// Передаєм мілісікунди отримує години:минути:секунди
export const getTimeMilliseconds = (milliseconds) => {
  // seconds
  let seconds = milliseconds / 1000;
  seconds = Math.round((seconds %= 60));
  // /seconds

  // minutes
  let minutes = Math.trunc(milliseconds / 60000);
  minutes = Math.trunc((minutes %= 60));
  // /minutes

  let hours = Math.trunc(milliseconds / 3600000);

  if (seconds < 10) seconds = '0' + seconds;
  if (minutes < 10) minutes = '0' + minutes;

  return hours + ':' + minutes + ':' + seconds;
};

// Порівнює два масива
export const isArraysEqual = (firstArray, secondArray) => {
  return firstArray.toString() === secondArray.toString();
};
// Перевіряє чи існує певний елемент у масиві
export const isArraysIncludes = (array, value) => {
  return array.includes(value);
};

//В масиві searchArray в кожному обєкті по ключу itemSearch  шукає текст який совпадає з textSearch створює новий масив  з цих обєктів і повертає його
export const searchSimilarText = (searchArray, itemSearch, textSearch) => {
  const result = [];

  // Видаляє неприпустимі символи для метода "search" (Якщо їх не видалити буде помилка)
  const textSearchReplace = textSearch.replace(/([.?*+^$[\]\\(){}|-])/g, '');
  try {
    searchArray.forEach((item) => {
      if (item[itemSearch].toLowerCase().search(textSearchReplace.toLowerCase().trim()) != -1) {
        result.push(item);
      }
    });
    return result;
  } catch (e) {
    alert('Помилка при пошуку!!!');
    return [];
  }
};
